import { Heading } from '@afterpaytouch/core'
import React, { useEffect } from 'react'
import { AddMobile, BackLink, Head } from '../../component'
import { Route } from '../../config/router'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutError, CheckoutPage } from '../../model'
import { useAppRouter, useAppDispatch, setCheckoutError } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'

export const AddMobilePage: CheckoutPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const { headingSize } = useCheckoutSizes()

  const pageTitle = `${t('common:brandName')}` // TODO: [accessibility] fix page title to be descriptive

  useEffect(() => {
    router.prefetch(Route.VERIFY)
    router.prefetch(Route.TERMINAL_ERROR)
  }, [])

  const onSuccessHandler = (): void => {
    router.push(Route.VERIFY)
  }

  const onTerminalError = (e: CheckoutError): void => {
    dispatch(setCheckoutError(e))
    router.push(Route.TERMINAL_ERROR)
  }

  return (
    <>
      <Head title={pageTitle} />
      <BackLink backTo={Route.ENTER_EMAIL} />
      <Heading size={headingSize}>{t('addMobile:heading')}</Heading>
      <AddMobile onSuccess={onSuccessHandler} onTerminalError={onTerminalError} />
      <TrackPageViewed />
    </>
  )
}
